import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface IDateFilterTypeToggle {
  value: string;
  option1Text: string;
  option2Text: string;
  onChange: (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    value: string
  ) => void;
}

export const ControlledToggleButtons = ({
  value,
  option1Text,
  option2Text,
  onChange,
}: IDateFilterTypeToggle) => {
  const isDesktop = useIsDesktop();

  const isOption1Selected = value === option1Text;

  return (
    <ToggleButtonGroup
      exclusive
      value={value}
      onChange={onChange}
      sx={{
        bgcolor: '#fff',
        borderRadius: '8px',
        label: {
          cursor: 'pointer',
        },
        '.Mui-selected': {
          bgcolor: 'purple2.main',
          '& label': {
            color: 'white',
            fontWeight: 700,
          },
          '&:hover': {
            bgcolor: 'purple2.main',
          },
        },
      }}
    >
      <ToggleButton
        sx={{
          width: isDesktop ? '200px' : '117px',
          height: isDesktop ? '48px' : '40px',
          borderRadius: '6px',
        }}
        value={option1Text}
      >
        <Typography
          variant={isOption1Selected ? 'body1' : 'body3'}
          component='label'
        >
          {option1Text}
        </Typography>
      </ToggleButton>
      <ToggleButton
        sx={{
          width: isDesktop ? '200px' : '117px',
          height: isDesktop ? '48px' : '40px',
          borderRadius: '6px',
        }}
        value={option2Text}
      >
        <Typography
          variant={!isOption1Selected ? 'body1' : 'body3'}
          component='label'
        >
          {option2Text}
        </Typography>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
